// eslint-disable-next-line
module.exports.validator = function (options) {
    let validate, msg;
    console.log("%%%%%", options);
    if (options.required !== undefined && options.required) {
      if (options.value !== null) {
        if (typeof options.value == "string" && options.value.trim() !== "") {
          validate = true;
          msg = null;
        } else {
          if (options.value.length > 0) {
            validate = true;
            msg = null;
          } else {
            validate = false;
            msg = "Required field";
          }
        }
      } else {
        validate = false;
        msg = "Required field";
      }
    }
    if (options.minLength !== undefined && Number.isInteger(options.minLength)) {
      if (options.value !== null && options.value.length >= options.minLength) {
        validate = true;
        msg = null;
      } else {
        validate = false;
        msg = "Minimum length is " + options.minLength;
      }
    }
    if (options.maxLength !== undefined && Number.isInteger(options.maxLength)) {
      if (options.value !== null && options.value.length <= options.maxLength) {
        validate = true;
        msg = null;
      } else {
        validate = false;
        msg = "Maximum length is " + options.maxLength;
      }
    }
    if (options.pattern !== undefined && options.pattern !== null) {
      if (options.value !== null && eval(options.pattern).test(options.value)) {
        validate = true;
        msg = null;
      } else {
        validate = false;
        msg = "Enter valid value";
      }
    }
  
    return { validate, message: msg };
  };
  